//----------Import Layouts----------
import Contents from '../Layouts/Contents'
import Credit from '../Layouts/Credits'
import styles from './index.module.scss'
//----------Import Tables----------
import Table from './table'

const Commands = () => {
  return (
    <div>
        <div className={styles.layout}>
            <Contents />
            <div className={styles.start}>
                <div>
                    <h1>All Commands</h1>
                    <p>Browse here for all related commands.</p>
                </div>

                <div>
                  <Table />
                </div>
                
            </div>
        </div>
        <Credit />
    </div>
  )
}

export default Commands